import React, { useState } from 'react';
import { Modal, Button, Table } from 'react-bootstrap';
import { useQuery } from 'react-query';
import { CME_KHOA_DAO_TAO_API } from '../../../../utils/apiUrl';
import { Get } from '../../../../utils/httpProvider';
import moment from 'moment';
import UserInfoCell from '../duyetHoSo/UserInfoCell';

const CMEEventParticipantModal = ({ isOpen, handleClose, eventData }) => {
    const { data, isLoading } = useQuery(
        ['cmeParticipants', eventData?.id],
        () => Get(`${CME_KHOA_DAO_TAO_API.GET_PARTICIPANTS}/${eventData?.id}`),
        { enabled: !!eventData?.id && isOpen }
    );

    const participants = data?.$values || data || [];

    const [searchTerm, setSearchTerm] = useState('');

    const filteredParticipants = participants.filter(item => {
        return !searchTerm || item.userId?.toLowerCase().includes(searchTerm.toLowerCase());
    });

    return (
        <Modal show={isOpen} onHide={handleClose} size="xl" backdrop="static" style={{ zIndex: '9999' }}>
            <Modal.Header closeButton className="bg-info text-white">
                <Modal.Title>
                    Danh sách nhân viên đã cấp điểm - {eventData?.tenKhoaDaoTao}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="row mb-3">
                    <div className="col-md-6">
                        <div className="input-group">
                            <div className="input-group-prepend">
                                <span className="input-group-text bg-white border-right-0"><i className="fas fa-search text-muted"></i></span>
                            </div>
                            <input 
                                type="text" 
                                className="form-control border-left-0" 
                                placeholder="Tìm kiếm theo CCCD/Username..." 
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                            />
                        </div>
                    </div>
                    <div className="col-md-6 text-right pt-2">
                        <small className="text-muted font-italic">Đang hiển thị {filteredParticipants.length} / {participants.length} nhân viên</small>
                    </div>
                </div>

                <div className="table-responsive" style={{ maxHeight: '600px' }}>
                    <Table striped bordered hover size="sm">
                        <thead className="bg-light">
                            <tr>
                                <th className="text-center" style={{ width: '50px' }}>STT</th>
                                <th>CCCD</th>
                                <th>Họ tên</th>
                                <th>Vai trò</th>
                                <th className="text-center">Số điểm</th>
                                <th className="text-center">Ngày cấp</th>
                            </tr>
                        </thead>
                        <tbody>
                            {isLoading ? (
                                <tr><td colSpan={6} className="text-center py-4">Đang tải dữ liệu...</td></tr>
                            ) : filteredParticipants.length === 0 ? (
                                <tr><td colSpan={6} className="text-center py-4 text-muted">Không tìm thấy nhân viên nào phù hợp.</td></tr>
                            ) : (
                                filteredParticipants.map((item, idx) => (
                                    <tr key={item.id}>
                                        <td className="text-center">{idx + 1}</td>
                                        <td>
                                            <UserInfoCell userId={item.userId} mode="username" />
                                        </td>
                                        <td>
                                            <UserInfoCell userId={item.userId} mode="name" />
                                        </td>
                                        <td>{item.vaiTro}</td>
                                        <td className="text-center font-weight-bold text-primary">{item.points}</td>
                                        <td className="text-center text-muted">
                                            {item.createdDate ? moment(item.createdDate).format('DD/MM/YYYY HH:mm') : '-'}
                                        </td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </Table>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>Đóng</Button>
            </Modal.Footer>
        </Modal>
    );
};

export default CMEEventParticipantModal;
